import * as angular from "angular";
import {IController} from "angular";

export class CommonsActionPanelComponent implements IController {
  panelRef: any;
  actions: any;
  bringozIdContext: string;

  public suffix: string = '-action-panel-default';

  constructor() {
  }

  $onInit() {
    if (this.bringozIdContext) {
      this.suffix = `-action-panel-${this.bringozIdContext}`;
    }
  }

  onAction(action) {
    this.panelRef.config.onCloseSuccess(this.panelRef, action);
  };

  onClose() {
    this.panelRef.destroy();
  }

}

angular
  .module('bringoz.admin.commons')
  .component('commonsActionPanel', {
    bindings: {
      panelRef: '<',
      actions: '<',
      header: '<?',
      bringozIdContext: '<?'
    },
    templateUrl: 'app/modules/commons/components/commons-action-panel/commons-action-panel.html',
    controller: CommonsActionPanelComponent
  });
